// defines the individual toast product/tier that a guest could be using to place their order
enum ToastProduct {
  OOPro = 'OOPro',
  OOBasic = 'OOBasic',
  ToastLocal = 'ToastLocal',
  Sites = 'Sites'
}

export default ToastProduct;
